<template>
    <div id="threed">
      <div class="content">
        <Logo/>
        <Nav/>
      </div>
    </div>
</template>

<script>
import * as THREE from "three"
import Logo from '@/components/Logo.vue'
import Nav from '@/components/Nav.vue'
// import RendererStats from 'three-webgl-stats';
// const OrbitControls = require("three-orbitcontrols");
const TrackballControls = require('three-trackballcontrols')
require('@/assets/disturb.jpg')

export default {
  components: {
    Logo,
    Nav
  },
  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: null,
      light1: null,
      light2: null,
      light3: null,
      light4: null,
      light5: null,
      light6: null,
      clock: new THREE.Clock(),
    //   stats: new RendererStats(),
      divWidth: null,
      divHeight: null,
      timg:'@/assets/disturb.jpg',
      container: null
    };
  },
  methods: {
    init: function() {
      this.container = document.getElementById("threed");

      // CAMERA
      this.camera = new THREE.PerspectiveCamera(
        50,
        this.container.clientWidth / this.container.clientHeight,
        1,
        300
      );
      this.camera.position.set(20, 35, 150);
      this.camera.lookAt(1, 100, 10);
      // SCENE
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0x040306);
      this.scene.fog = new THREE.Fog(0x040306, 10, 300);
      // CONTROLS
      this.controls = new TrackballControls(this.camera);
      this.controls.rotateSpeed = 1.0;
      this.controls.zoomSpeed = 1.2;
      this.controls.panSpeed = 0.8;
      this.controls.noZoom = true;
      this.controls.noPan = false;
      this.controls.staticMoving = false;
      this.controls.dynamicDampingFactor = 0.15;
      this.controls.keys = [65, 83, 68];
      // TEXTURES
      var textureLoader = new THREE.TextureLoader();
      var texture = textureLoader.load(this.timg);
      texture.repeat.set(20, 10);
      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.format = THREE.RGBFormat;
      // MATERIALS
      var groundMaterial = new THREE.MeshPhongMaterial({
        color: 0x204E7A
      });
      var objectMaterial = new THREE.MeshStandardMaterial({
        color: 0xffffff,
        roughness: 0.5,
        metalness: 1.0
      });
      // GROUND
      var gmesh = new THREE.Mesh(
        new THREE.PlaneBufferGeometry(800, 400, 2, 2),
        groundMaterial
      );
      gmesh.position.y = -5;
      gmesh.rotation.x = -Math.PI / 2;
      this.scene.add(gmesh);
      // OBJECTS
      var objectGeometry = new THREE.OctahedronBufferGeometry(1, 0);
      // var objectGeometry = new THREE.SphereBufferGeometry( 0.5, 32, 32 );
      // var objectGeometry = new THREE.TorusBufferGeometry(1.5, 0.4, 8, 16);
      for (var i = 0; i < 1200; i++) {
        var mesh = new THREE.Mesh(objectGeometry, objectMaterial);
        // var time = Date.now() * 0.00025;
        // var d = 150;
        mesh.position.x = 400 * (0.5 - Math.random());
        mesh.position.y = 50 * (0.5 - Math.random()) + 25;
        mesh.position.z = 200 * (0.5 - Math.random());
        mesh.rotation.y = 3.14 * (0.5 - Math.random());
        mesh.rotation.x = 3.14 * (0.5 - Math.random());
        mesh.matrixAutoUpdate = false;
        mesh.updateMatrix();
        this.scene.add(mesh);
        // mesh.position.x = Math.sin(time * 0.7) * d;
      }
      // LIGHTS
      var intensity = 2.25;
      var distance = 100;
      var decay = 1.5;
      var c1 = 0x204e7A,
        c2 = 0x57385c,
        c3 = 0xa75265,
        c4 = 0xec7263,
        c5 = 0xfebe7e,
        c6 = 0x03A688;
      var sphere = new THREE.SphereBufferGeometry(0.25, 16, 8);
      this.light1 = new THREE.PointLight(c1, intensity, distance, decay);
      this.light1.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c1 }))
      );
      this.scene.add(this.light1);
      this.light2 = new THREE.PointLight(c2, intensity, distance, decay);
      this.light2.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c2 }))
      );
      this.scene.add(this.light2);
      this.light3 = new THREE.PointLight(c3, intensity, distance, decay);
      this.light3.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c3 }))
      );
      this.scene.add(this.light3);
      this.light4 = new THREE.PointLight(c4, intensity, distance, decay);
      this.light4.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c4 }))
      );
      this.scene.add(this.light4);
      this.light5 = new THREE.PointLight(c5, intensity, distance, decay);
      this.light5.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c5 }))
      );
      this.scene.add(this.light5);
      this.light6 = new THREE.PointLight(c6, intensity, distance, decay);
      this.light6.add(
        new THREE.Mesh(sphere, new THREE.MeshBasicMaterial({ color: c6 }))
      );
      this.scene.add(this.light6);
      var dlight = new THREE.DirectionalLight(0xffffff, 0.05);
      dlight.position.set(0.5, 1, 0).normalize();
      this.scene.add(dlight);
      // RENDERER
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
      this.container.appendChild(this.renderer.domElement);
      this.renderer.gammaInput = true;
      this.renderer.gammaOutput = true;
      // STATS
      // this.stats = new renderStats();
    //   this.container.appendChild(this.stats.domElement);
      //
      window.addEventListener("resize", this.onWindowResize, false);
    },
    animate: function() {
      requestAnimationFrame(this.animate);
      // this.controls.rotation.x += 0.005
      // this.controls.rotation.y += 0.01

      this.render();
    //   this.stats.update();
    },
    onWindowResize: function() {
      this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
      this.controls.handleResize();
    },
    render: function() {
      var time = Date.now() * 0.000325;
      var d = 140;
      this.light1.position.x = Math.sin(time * 0.7) * d;
      this.light1.position.z = Math.cos(time * 0.3) * d;
      this.light2.position.x = Math.cos(time * 0.3) * d;
      this.light2.position.z = Math.sin(time * 0.7) * d;
      this.light3.position.x = Math.sin(time * 0.7) * d;
      this.light3.position.z = Math.sin(time * 0.5) * d;
      this.light4.position.x = Math.sin(time * 0.3) * d;
      this.light4.position.z = Math.sin(time * 0.5) * d;
      this.light5.position.x = Math.cos(time * 0.3) * d;
      this.light5.position.z = Math.sin(time * 0.5) * d;
      this.light6.position.x = Math.cos(time * 0.7) * d;
      this.light6.position.z = Math.cos(time * 0.5) * d;
      this.controls.update(this.clock.getDelta());
      this.renderer.render(this.scene, this.camera);
    }
  },
  mounted() {
    this.init();
    this.animate();
  }
};
</script>


<style lang="scss">
#threed {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100vh;
  cursor: move;
}
.content {
  // background: rgba(0, 0, 0, 0.75);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  a {
    cursor: pointer;
  }
  // padding: 25px;
  font-size: 20px;
  font-weight: 500;
  width: 80%;
  // max-width: 95%;
};
</style>
